/** Browser preferences remain optional when storage is unavailable. */
export function readPreference(key, fallback = "") {
  try { return localStorage.getItem(key) ?? fallback; } catch { return fallback; }
}
export function writePreference(key, value) {
  try { localStorage.setItem(key, String(value)); } catch { /* The UI still works in this page. */ }
}
/** Only same-origin application paths can be used for return navigation. */
export function safeReturnPath(value, fallback = "/dashboard") {
  return typeof value === "string" && /^\/(?!\/)/.test(value) && !/[\\\u0000-\u001f]/.test(value) ? value : fallback;
}
